import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { sdk } from '@/services/sdk';
import { useFetch } from '@/hooks/useFetch';
import { PageHeader } from '@/components/kit';
import { BackLink, recordGate } from '@/components/record';
import ReviewForm, { reviewToForm } from '@/components/admin/ReviewForm';
import { REVIEW_FIELDS } from '@/shared/fields';
import { committed } from '@/shared/data';

export const route = { path: '/admin/reviews/:id/edit', layout: 'owner', access: "['Admin_c','Staff_c'].includes(profile)" };

export default function EditReview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const { data: review, loading, error, run } = useFetch(
    () => sdk.table('reviews_c').select(REVIEW_FIELDS).get(id).then((r) => r.data ?? null),
    [id],
  );

  const back = <BackLink to={`/admin/reviews/${id}`} label="Back to Review" />;
  const gate = recordGate({ back, loading, record: review, error, run, what: 'Review' });
  if (gate) return gate;

  async function save(payload) {
    setSaving(true);
    try {
      const res = await sdk.table('reviews_c').update({ Id: review.Id, ...payload });
      if (!committed(res, 'Review saved')) return;
      navigate(`/admin/reviews/${review.Id}`);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mx-auto max-w-5xl">
      {back}
      <PageHeader eyebrow="Edit review" title={review.Name} />
      <ReviewForm
        key={review.Id}
        initial={reviewToForm(review)}
        onSubmit={save}
        saving={saving}
        submitLabel="Save changes"
        cancelTo={`/admin/reviews/${review.Id}`}
      />
    </div>
  );
}
